/** Open / closed state of a panel group: the toggle's `aria-expanded` and the body's `hidden`, kept together. */
export class PrototypeAccordion {
    public static bind(group: HTMLElement) {
        group.querySelector('[data-prototype-group-toggle]')?.addEventListener('click', () => {
            PrototypeAccordion.setExpanded(group, !PrototypeAccordion.isExpanded(group));
        });
    }

    public static setExpanded(group: HTMLElement, expanded: boolean) {
        group.querySelector('[data-prototype-group-toggle]')?.setAttribute('aria-expanded', expanded.toString());
        const body = group.querySelector<HTMLElement>('[data-prototype-group-body]');
        if (body) {
            body.hidden = !expanded;
        }
    }

    public static isExpanded(group: HTMLElement): boolean {
        return group.querySelector('[data-prototype-group-toggle]')?.getAttribute('aria-expanded') === 'true';
    }
}
